const questions = [
    "Things usually don't bother me",
    "I find it very hard to talk in front of a group",
    "There are a lot of things about myself that I'd change if I could",
    "I can make up my mind without too much trouble",
    "I am a lot of fun to be with",
    "I get upset easily at home",
    "It takes me a long time to get used to anything new",
    "I am popular with people of my own age",
    "My family usually considers my feelings",
    "I give in very easily",
    "My family expects too much of me",
    "It's pretty tough to be me",
    "Things are all mixed up in my life",
    "People usually follow my ideas",
    "I have a low opinion about myself",
    "There have been many times when I have wished to leave home",
    "I often feel upset with my work",
    "I'm not as nice looking as most people",
    "If I have something to say, I usually say it",
    "My family understands me",
    "Most people are more likeable than me",
    "I usually feel as if my family is pushing me",
    "I often get discouraged with what I am doing",
    "I often wish I were someone else",
    "I can't be depended on"
]

export default questions;